export {
  MESSAGING_DELIVERY_OFF,
  type MessagingDeliveryChannel,
} from '@littlebird/ui-utils';

export const MessagingChannelTypes = {
  IMESSAGE: 'imessage',
  WHATSAPP_BUSINESS: 'whatsapp_business',
} as const;

export type MessagingChannelType =
  (typeof MessagingChannelTypes)[keyof typeof MessagingChannelTypes];

export const MESSAGING_CHANNEL_TYPES: MessagingChannelType[] = Object.values(
  MessagingChannelTypes
);

export const MESSAGING_CHANNEL_LABELS: Record<MessagingChannelType, string> = {
  [MessagingChannelTypes.IMESSAGE]: 'iMessage',
  [MessagingChannelTypes.WHATSAPP_BUSINESS]: 'WhatsApp',
};

export const MESSAGING_CHANNEL_DESCRIPTIONS: Record<
  MessagingChannelType,
  string
> = {
  [MessagingChannelTypes.IMESSAGE]: 'Message Littlebird from any Apple device',
  [MessagingChannelTypes.WHATSAPP_BUSINESS]: 'Message Littlebird from WhatsApp',
};

// WhatsApp's 24-hour customer service window
export const WHATSAPP_REPLY_WINDOW_NOTE =
  "WhatsApp lets Littlebird message you only within 24 hours of your last message. After that, Littlebird can't message you there, routine reports included, until you message it again. Littlebird sends a short summary of what's waiting instead. iMessage has no such limit, so if you have both, choose iMessage.";

export const CHANNEL_VIA_PARAMS = ['imessage', 'whatsapp'] as const;
export type ChannelViaParam = (typeof CHANNEL_VIA_PARAMS)[number];

export const CHANNEL_TYPE_BY_VIA: Record<
  ChannelViaParam,
  MessagingChannelType
> = {
  imessage: MessagingChannelTypes.IMESSAGE,
  whatsapp: MessagingChannelTypes.WHATSAPP_BUSINESS,
};
